import React from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import ReactDatePicker from 'react-datepicker'
import { FaDownload } from 'react-icons/fa'

export const ReporteMensual = () => {
    const [EmbarquesDespachados, setEmbarquesDespachados] = React.useState<any[]>([])
    const [Inicio, setInicio] = React.useState<string>(new Date().toISOString().split('T')[0])
    const [Fin, setFin] = React.useState<string>(new Date().toISOString().split('T')[0])

    const GetEmbarquesDespachados = () => {}

    const exportarEmbarques = () => {}
  return (
    <div className='px-2' style={{width:'85%'}}>
    <Card>
        <Card.Header>Reporte Mensual</Card.Header>
        <Card.Body>
            <Row>
                <Col xs={3}>
                    <Form.Label style={{width:'100%'}}>
                        Fecha Inicial
                        <Form.Control
                            defaultValue={Inicio}
                            type='date'
                            name='Inicio'
                            placeholder='Inicio'
                            title='Inicio'
                            alt='Inicio'
                            data-date-format='YYYY-mm-dd'
                            onChange={(e) => setInicio(e.target.value)}
                            size='sm'
                        />
                    </Form.Label>
                </Col>
                <Col xs={3}>
                    <Form.Label style={{width:'100%'}}>
                        Fecha Final
                        <Form.Control
                            defaultValue={Fin}
                            type='date'
                            name='Fin'
                            placeholder='Fin'
                            title='Fin'
                            alt='Fin'
                            onChange={(e) => setFin(e.target.value)}
                            size='sm'
                        />
                    </Form.Label>
                </Col>
                <Col style={{margin:'auto 0px'}}>
                        <Button className="me-2" variant="primary" onClick={GetEmbarquesDespachados}>Generar</Button>
                        { EmbarquesDespachados.length > 0 ? <Button onClick={exportarEmbarques}><FaDownload/>&nbsp;Excel</Button> : "" }
                </Col>
            </Row>
            <DataTable columns={[]} data={[]}/>
        </Card.Body>
    </Card>
    </div>
  )
}
